module.exports = "https://cdn-assessment.mathletics.com/app/112/assets/images/a0e473f1a1658e894fbcf2b29be4ce2c.svg";